import React from 'react'

const ModelTitle = ({ model }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        fontSize: 20,
        fontWeight: 500,
        marginTop: 15,
      }}
    >
      {model.title}
    </div>
  )
}

export default ModelTitle
